'use client';

import { useTranslation } from 'next-i18next';

import { Text } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { IndicatorButton } from '@app/components/atoms/indicator-button';
import { FilterToggleButtonProps } from '@app/components/molecules/filter-toggle-button';
import { useActiveFilters } from '@app/hooks/useActiveFilters';
import { useSearch } from '@app/hooks/useSearch';

export const FilterToggleButton = ({ showCounter = true, onClick }: FilterToggleButtonProps) => {
    const { t } = useTranslation('common', { keyPrefix: 'filters' });
    const { toggleFiltersVisibility } = useSearch();
    const { activeFiltersCount } = useActiveFilters();

    return (
        <IndicatorButton
            withIndicator={activeFiltersCount > 0}
            icon={<IconsLinear.Settings color={'secondary.solid'} w={4} h={4} />}
            onClick={onClick || toggleFiltersVisibility}
            aria-label={t('filter')}
        >
            {t('filter')}
            {showCounter && activeFiltersCount ? (
                <Text as={'span'} fontWeight={'normal'}>
                    {' '}
                    ({activeFiltersCount})
                </Text>
            ) : null}
        </IndicatorButton>
    );
};
